import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { hasDecision, setCookieConsent, onOpenPreferences } from "@/lib/cookieConsent";

/**
 * Cookie banner. Shown until the visitor makes a choice; reopened by the
 * footer "Cookie preferences" link (via onOpenPreferences). In the EU/EEA,
 * UK and Switzerland nothing tracks until Accept (src/lib/cookieConsent.ts);
 * elsewhere analytics run until Decline. Accept and Decline weigh the same.
 */
const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!hasDecision()) setOpen(true);
    return onOpenPreferences(() => setOpen(true));
  }, []);

  if (!open) return null;

  const choose = (analytics: boolean) => {
    setCookieConsent(analytics);
    setOpen(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-[calc(56px+env(safe-area-inset-bottom))] md:bottom-0 z-nav p-3 md:p-4 pointer-events-none">
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-card border border-border bg-card shadow-floating p-4 md:p-5">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <p className="text-sm text-muted-foreground leading-relaxed">
            We use cookies and similar tools, including analytics (Google
            Analytics and LogRocket), to run this site and improve it. You can
            accept or decline non-essential analytics. See our{" "}
            <Link to="/cookies" className="text-primary underline-offset-4 hover:underline">
              Cookie Policy
            </Link>
            .
          </p>
          <div className="flex items-center gap-2 shrink-0">
            <Button variant="outline" size="sm" onClick={() => choose(false)}>
              Decline
            </Button>
            <Button variant="outline" size="sm" onClick={() => choose(true)}>
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
